import Vue from 'vue';
import VueResource from 'vue-resource';

import TourList from 'templates/TourList.vue';


export default {
    init: function () {
        // only if our v-app exists do we bootstrap Vue
        if ($('.v-app').length <= 0) {
            return;
        }

        // use resource
        Vue.use(VueResource);


        Vue.component('tour-list', TourList);

        Vue.filter('capitalize', function (value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        });

        Vue.filter('title', function(value) {
            const words = value.split('-');

            for(let i = 0; i < words.length; i++) {
                let word = words[i];
                words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            }

            return words.join(' ');
        });

        Vue.filter('lowercase', function(value) {
            return value.toLowerCase();
        });


        /**
         * Get and set the page URL within a scoped environment
         */
        Vue.mixin({
            computed: {
                pageURL: {
                    // getter
                    get: function () {
                        return window.location.href;
                    },
                    // setter
                    set: function (newValue) {
                        window.location.href = newValue;
                    },
                },
            },
        });

        Vue.mixin({
            computed: {
                dataLayer: {
                    get() {
                        return window[window.gtm4wp_datalayer_name];
                    },
                },
            },
        });

        $('.v-app').each(function() {
            new Vue({
                el: this,
            });
        });

        // WP-API options

        // Vue.http.options.root = window.wpApiSettings.root;
        // Vue.http.headers.common['X-WP-Nonce'] =  window.wpApiSettings.nonce;
    },

}
